export default __webpack_public_path__ + "static/hmeGraphic2-eaa04c7deb13bbaa2752606270fcb9cb.svg";